import React from 'react';
import { Card } from 'antd';
import { SkHeader, SkStatCards, SkTabsBar, SkTable } from './_primitives';

/** ReferralsPage — 5 stats, 2 tabs, referrals table */
const ReferralsPageLoader = () => (
  <div className="w-full p-4 md:p-6">
    <SkHeader actions={1} />
    <SkStatCards count={5} />
    <Card className="shadow-sm">
      <SkTabsBar tabs={2} />
      <div className="overflow-x-auto">
        <SkTable rows={8} cols={6} inCard={false} />
      </div>
    </Card>
  </div>
);

export default ReferralsPageLoader;
